import { AppState, getBrowserTabId } from "./Pjax";
import tinymce, { Editor } from "tinymce";
import { ConditionalLog, } from "./tools";
import { createAndShowAlert } from "./app";
import { vertaal } from "./vertaal";

const interval = 300 * 1000;

export function registerSessionPinger() {
    let lastPing = Date.now();
    let sessionExpired = false;

    async function pingSession() {
        const elapsed = Date.now() - lastPing;

        const rootOrganisatie = AppState()?.getAttribute("data-rootorg");
        const browserTabId = getBrowserTabId();

        if (!rootOrganisatie || !browserTabId || sessionExpired || elapsed < interval) {
            return;
        }

        lastPing = Date.now();
        const response = await fetch(
            `/pingsession/${rootOrganisatie}/${browserTabId}`,
            {
                method: "GET",
                credentials: "same-origin",
            });

        if (response.ok) {
            ConditionalLog.log("Sessie is actief");
        } else {
            sessionExpired = true;
            createAndShowAlert(
                vertaal(
                    "Foutmelding", 
                    "Error"
                ),
                vertaal(
                    "Sessie verlopen, acties werken niet meer. Stel uw wijzigingen veilig en herlaad de pagina.",
                    "Session expired, actions no longer work. Remember your changes and reload the page."
                )
            );
        }
    }

    addEventListener("keypress", pingSession);
    tinymce.on('addeditor', e => {
        e.editor.options.set('init_instance_callback', function (editor: Editor) { editor.on('Change', pingSession);});
    });
}
